import { render, staticRenderFns } from "./singleClass.vue?vue&type=template&id=63ab6582&scoped=true&"
import script from "./singleClass.vue?vue&type=script&lang=js&"
export * from "./singleClass.vue?vue&type=script&lang=js&"
import style0 from "./singleClass.vue?vue&type=style&index=0&id=63ab6582&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ab6582",
  null
  
)

export default component.exports